import { CalendarOutlined, CheckCircleOutlined, EditOutlined, HomeOutlined, IdcardOutlined, MailOutlined, PhoneOutlined, ReloadOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Card, Space, Tag } from 'antd'
import React from 'react'
import { frenchDate, isConnectedUserFromPOOL } from '../../../variables/functions'
import { LOGGED_USER } from '../../../variables/constants'

const SideBarDetailsUtilisateur = ({ utilisateur, cardStyle, showReinitialisationConfirm, setEditModalOpen, primaryButtonStyle, dangerButtonStyle }) => {
    const isPoolUser = isConnectedUserFromPOOL();
    const isAdminProfile = ((LOGGED_USER?.profil?.nom || "")).toLowerCase().includes("admin");
    const hasSecurityPrivileges = isPoolUser || isAdminProfile;
    const isSelfTarget = Boolean(
        (LOGGED_USER?.codeId && utilisateur?.codeId && LOGGED_USER.codeId === utilisateur.codeId)
        || (LOGGED_USER?.email && utilisateur?.email && LOGGED_USER.email === utilisateur.email)
        || (LOGGED_USER?.username && utilisateur?.username && LOGGED_USER.username === utilisateur.username)
    );
    const canReset = Boolean(utilisateur?.active && hasSecurityPrivileges && !isSelfTarget);
    const disabledDangerButtonStyle = {
        backgroundColor: '#E5E7EB',
        borderColor: '#E5E7EB',
        color: '#9CA3AF',
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
    };

    return (
        <Card style={cardStyle}>
            <div style={{
                textAlign: 'center',
                paddingTop: '6px',
                paddingBottom: '14px'
            }}>
                <Avatar
                    size={120}
                    style={{
                        backgroundColor: '#242166',
                        fontSize: '48px',
                        marginBottom: '2px',
                        border: '4px solid #E6F0FF'
                    }}
                >
                    {utilisateur?.personne?.prenom?.charAt(0)}{utilisateur?.personne?.nom?.charAt(0)}
                </Avatar>

                <h2 style={{
                    fontSize: '24px',
                    fontWeight: '700',
                    color: '#242166',
                    marginBottom: '8px',
                    marginTop: '6px'
                }}>
                    {utilisateur?.personne?.prenom} {utilisateur?.personne?.nom}
                </h2>

                <Tag
                    color={utilisateur?.active ? "success" : "error"}
                    style={{
                        padding: '0px 16px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '20px',
                        border: 'none'
                    }}
                >
                    {utilisateur?.profil?.nom}
                </Tag>
            </div>

            <div style={{
                borderTop: '2px solid #E6F0FF',
                paddingTop: '14px',
                marginTop: '8px'
            }}>
                <h3 style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#242166',
                    marginBottom: '20px'
                }}>
                    Informations détaillées
                </h3>

                <Space direction="vertical" size={16} style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <UserOutlined style={{ color: '#242166', fontSize: '18px', marginTop: '2px' }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Username
                            </div>
                            <div style={{ fontSize: '14px', color: '#2E2E2E', fontWeight: '500' }}>
                                @{utilisateur?.username}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <MailOutlined style={{ color: '#242166', fontSize: '18px', marginTop: '2px' }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Email
                            </div>
                            <div style={{ fontSize: '14px', color: '#2E2E2E', fontWeight: '500' }}>
                                {utilisateur?.email}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <PhoneOutlined style={{ color: '#242166', fontSize: '18px', marginTop: '2px' }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Contact
                            </div>
                            <div style={{ fontSize: '14px', color: '#2E2E2E', fontWeight: '500' }}>
                                (+228) {utilisateur?.personne?.contact}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <IdcardOutlined style={{ color: '#242166', fontSize: '18px', marginTop: '2px' }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Fonction
                            </div>
                            <div style={{ fontSize: '14px', color: '#2E2E2E', fontWeight: '500' }}>
                                {utilisateur?.personne?.fonction}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <HomeOutlined style={{ color: '#242166', fontSize: '18px', marginTop: '2px' }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Adresse
                            </div>
                            <div style={{ fontSize: '14px', color: '#2E2E2E', fontWeight: '500' }}>
                                {utilisateur?.personne?.adresse}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <CalendarOutlined style={{ color: '#242166', fontSize: '18px', marginTop: '2px' }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Date de création
                            </div>
                            <div style={{ fontSize: '14px', color: '#2E2E2E', fontWeight: '500' }}>
                                {utilisateur?.createdAt}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <CalendarOutlined style={{ color: '#242166', fontSize: '18px', marginTop: '2px' }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Dernière connexion
                            </div>
                            <div style={{ fontSize: '14px', color: '#2E2E2E', fontWeight: '500' }}>
                                {frenchDate(utilisateur?.lastConnexion)}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        <CheckCircleOutlined style={{
                            color: utilisateur?.active ? '#10B981' : '#DC2626',
                            fontSize: '18px',
                            marginTop: '2px'
                        }} />
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>
                                Statut
                            </div>
                            <Tag
                                color={utilisateur?.active ? "success" : "error"}
                                style={{ marginTop: '4px' }}
                            >
                                {utilisateur?.active ? "Actif" : "Inactif"}
                            </Tag>
                        </div>
                    </div>
                </Space>
            </div>

            <div style={{
                borderTop: '2px solid #E6F0FF',
                paddingTop: '24px',
                marginTop: '24px'
            }}>
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <Button
                        type="primary"
                        icon={<EditOutlined />}
                        block
                        onClick={() => setEditModalOpen(true)}
                        disabled={!utilisateur?.active}
                        style={primaryButtonStyle}
                    >
                        Éditer
                    </Button>

                    <Button
                        icon={<ReloadOutlined />}
                        block
                        disabled={!canReset}
                        style={!canReset ? { ...dangerButtonStyle, ...disabledDangerButtonStyle } : dangerButtonStyle}
                        onClick={() => showReinitialisationConfirm(utilisateur?.email)}
                    >
                        Réinitialiser
                    </Button>
                </Space>
            </div>
        </Card>
    )
}

export default SideBarDetailsUtilisateur
